import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import SerieNotaFiscal from "model/fiscal/SerieNotaFiscal";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import SerieNotaFiscalService from "service/fiscal/SerieNotaFiscalService";
import UnidadeOrganizacionalService from "service/indicadores/UnidadeOrganizacionalService";

const serieNotaFiscalService = new SerieNotaFiscalService();
const unidadeOrganizacionalService = new UnidadeOrganizacionalService();

export default function SerieNotaFiscalCadastro() {
    const [serie, setSerie] = useState(new SerieNotaFiscal());
    const [unidades, setUnidades] = useState<UnidadeOrganizacional[]>([]);
    const [erro, setErro] = useState("");

    useEffect(() => {
        unidadeOrganizacionalService.getAll()
            .then(setUnidades)
            .catch(error => console.error("Erro ao buscar unidades organizacionais:", error));
    }, []);

    function validar() {
        if (!serie.unidadeOrganizacional || serie.numeroSerie < 0 || !serie.modelo ||
            !serie.ambiente || serie.controleNumeracao !== "EMPX") {
            setErro("Informe unidade, modelo, ambiente, número da série e controle de numeração.");
            return false;
        }
        setErro("");
        return true;
    }

    return (
        <BaseCadastro model={serie} service={serieNotaFiscalService}
            setModel={(value: SerieNotaFiscal) => setSerie({ ...value, controleNumeracao: "EMPX" })}
            getNewModel={() => new SerieNotaFiscal()} novoCadastro
            validar={validar} pathCadastro="/serieNotaFiscal" urlService="/serieNotaFiscal"
            tituloPagina="Série de nota fiscal">
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">Série de nota fiscal</label>
            </div>
            <div className="row">
                <div className="col-12 mb-3">
                    <Checkbox inputId="serie-ativa" checked={serie.ativa}
                        onChange={(e) => setSerie({ ...serie, ativa: !!e.checked })} />
                    <label htmlFor="serie-ativa" style={{ marginLeft: 8 }}>Ativa</label>
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Unidade organizacional</Label>
                    <Dropdown value={serie.unidadeOrganizacional?.id ?? null} options={unidades}
                        optionLabel="nome" optionValue="id" filter
                        onChange={(e) => setSerie({
                            ...serie,
                            unidadeOrganizacional: unidades.find(item => item.id === e.value) ?? null
                        })} style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Modelo</Label>
                    <Dropdown value={serie.modelo} options={serieNotaFiscalService.getListaModelo()}
                        optionLabel="label" optionValue="value"
                        onChange={(e) => setSerie({ ...serie, modelo: e.value })}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Número da série</Label>
                    <InputNumber value={serie.numeroSerie} min={0} useGrouping={false}
                        onValueChange={(e) => setSerie({ ...serie, numeroSerie: e.value ?? 0 })}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Ambiente</Label>
                    <Dropdown value={serie.ambiente} options={serieNotaFiscalService.getListaAmbiente()}
                        optionLabel="label" optionValue="value"
                        onChange={(e) => setSerie({ ...serie, ambiente: e.value })}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Controle de numeração</Label>
                    <InputText value={serieNotaFiscalService.getControleNumeracao("EMPX")} readOnly
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Descrição</Label>
                    <InputText value={serie.descricao ?? ""} maxLength={100}
                        onChange={(e) => setSerie({ ...serie, descricao: e.target.value })}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Último número utilizado</Label>
                    <InputNumber value={serie.ultimoNumeroUtilizado ?? 0} min={0} useGrouping={false}
                        onValueChange={(e) => setSerie({ ...serie, ultimoNumeroUtilizado: e.value ?? 0 })}
                        style={{ width: "100%" }} />
                </div>
            </div>
            {erro && <small className="p-error">{erro}</small>}
        </BaseCadastro>
    );
}
